import {Link, useNavigate} from "react-router";
import {FormEvent, useContext, useEffect, useState} from "react";

import GeneralContext from "../contexts/Gneral.tsx";
import ActivityContext, {IResolvedActivity} from "../contexts/Activity.tsx";
import {SelectedActivities} from "../components/SelectedActivities.tsx";
import {calcItem} from "../helpers/calcItem.ts";
import {isMobile} from "../helpers/isMobile.ts";

export function SelectSkill () {
    // @ts-ignore
    const {contents}  = useContext(GeneralContext);
    const  {resolvedActivities}  = useContext(ActivityContext);
    const [curent, setCurent]  = useState<number>(0);
    const [newSkil, setNewSkil] = useState<string>('');
    const [selectedSkil, setSlectedSkil] = useState<string>('');
    const [aditionaldSkils, setAditionaldSkils] = useState<string[]>([]);
    const navigate = useNavigate();

    let _resolvedActivities = resolvedActivities.map( (item) => {
        return Object.assign({},calcItem(item));
        return item;
    }).sort((a,b)=> {
        return a.r > b.r ? 1 : -1;
    });
    const DISTINCTION = isMobile() ? 0 : 125;
    const Activity = _resolvedActivities[curent].activity;
    const avSkils = Activity.skills;
    // const line = window.svgEl.querySelector('path.inner-line') as SVGPathElement;
    // // @ts-ignore
    // const size = window.svgEl.getBoundingClientRect();
    const container = document.querySelector('.personArea');
    // const containerParent = document.querySelector('.personArea');
    // const containerSize = container.getBoundingClientRect();
    //
    // const dx = containerParent.clientWidth/2 - container.clientWidth/2;
    // const dy = containerParent.clientHeight/2 - container.clientHeight/2;
    // _resolvedActivities = _resolvedActivities.map((item,index) =>{
    //     if(index <= 4){
    //         const length = line.getTotalLength();
    //         const point = line.getPointAtLength(length / 5 * index);
    //         item.position = Object.assign({},item.position);
    //         item.position.x = point.x -DISTINCTION + dx /* + (container.clientWidth  - window.svgEl.clientWidth) * k * ( kx < ky ? 1 : -1)*/ ;
    //         item.position.y = point.y -DISTINCTION + dy  /*+ (container.clientHeight - window.svgEl.clientHeight) *k * (ky < kx ? -1 : 1)*/;
    //     }
    //     return calcItem(item);
    // });
    const approve = () => {
        Activity.selectedSkill = selectedSkil;
        setSlectedSkil('');
        setAditionaldSkils([]);
        setNewSkil('');
    }
    let scale = 0
    _resolvedActivities.slice(0,5).forEach((item) => {
        if(scale < item.scale){
            scale = item.scale
        }
    })
    // const el = document.querySelector('.selectingAside');
    // let clientHeight = el?.clientHeight && isMobile() ? (window.innerHeight * 0.59 - (window.innerHeight - el.clientHeight))/2 : 0;
    useEffect(() => {
        if (curent > 0){
            const element = document.querySelector('.selectingAside ');
            element && element.getAnimations().forEach((anim) => {
                anim.cancel();
                anim.play();
            });
        }
    }, [curent]);
    let offset;
    scale = 1/(scale)* (isMobile() ? 0.8 : 0.8)
    // if(isMobile()){
    //     offset = {
    //         x : 0 ,
    //         y : -clientHeight
    //     }
    // }else {
        offset = {
            x : (_resolvedActivities[curent].position.x - container.clientWidth / 2 ) /2 *-scale ,
            y : (_resolvedActivities[curent].position.y - container.clientHeight / 2) /2 * -scale
        }
    // }

    useEffect(() => {
        setAditionaldSkils([]);
    }, []);
    return (<div className={'builder-screen'}>
        <div className={'selectingAside wide'}>
            <div className={'aside-content'}>
                <h1>{contents.selectSkillScreenHeading}{Activity.title}?</h1>
                <p>{contents.selectSkillScreenContent}</p>
            </div>
            <div className={"skills-holder"}>
                <ul className={"skills-list"}>
                    {[...avSkils, ...aditionaldSkils].map((skill, index) => {
                        return <li key={index}>
                            <input type={"radio"} value={skill} checked={selectedSkil === skill} name={"selectedSkill"}
                                   id={"skill-" + index} onChange={e => {
                                if (e.target.checked) {
                                    setSlectedSkil(e.target.value)
                                }
                            }}/>
                            <label htmlFor={"skill-" + index}>{skill}</label>
                        </li>
                    })}
                </ul>
                <div key={'skill'} className={'addSkill ' + (aditionaldSkils.length ? 'inactive' : '')}>
                    <input type={"radio"} name={'selectedSkill'} id={'skill'}/>
                    <label htmlFor='skill'>
                        <div className={"custom-skill"}>
                            <span className={"label"}>אחר</span>
                            <div className={"input-holder"}>
                                <input type={"text"} placeholder={isMobile() ? 'הוסף הנאה משלך' : 'הקלדה...'} value={newSkil} maxLength={35}
                                       onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                                           setNewSkil(e.target.value)
                                       }}

                                       onClick={(e) => {
                                           // @ts-ignore
                                           e.target.focus()
                                       }}
                                       onKeyUp={(e) => {
                                           if (e.keyCode === 13) {
                                               setAditionaldSkils([...aditionaldSkils, newSkil]);
                                               setSlectedSkil(newSkil)
                                               setNewSkil('');
                                           }
                                       }}
                                />
                                <button type={"submit"} value={"Set skill title"} disabled={!newSkil} onClick={e => {
                                    setAditionaldSkils([...aditionaldSkils, newSkil]);
                                    setSlectedSkil(newSkil)
                                    setNewSkil('');
                                }}></button>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
            {curent != 4 ?
                <button className={"btn"} disabled={!selectedSkil} onClick={() => {
                    approve();
                    setCurent(curent + 1);
                }}>המשך</button>
                :
                <button className={"btn btn-green"} disabled={!selectedSkil} onClick={() => {
                    approve();
                    setCurent(0);
                    navigate("/final");
                }}>סיום</button>
            }
        </div>
        <div className={'visualArea'}>
            <SelectedActivities activities={_resolvedActivities} scale={scale} hideInactive={true} offsetX={offset.x}
                                offsetY={offset.y} active={curent}/>
        </div>
    </div>);
}